module.exports = __webpack_public_path__ + "static/media/fly0160.e7a28bc3.webp";